export default __webpack_public_path__ + "static/media/Care_worker-01.66da4b01.png";